import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgNextStation = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 32,
	height: 32,
	viewBox: "0 0 32 32",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M4.94727 5.00002C5.19839 5.00002 5.43954 5.09988 5.61719 5.27736C5.79476 5.45493 5.89441 5.69617 5.89453 5.94728V26.791C5.89453 27.0423 5.7948 27.2833 5.61719 27.461C5.43951 27.6386 5.19854 27.7393 4.94727 27.7393C4.69605 27.7392 4.45498 27.6386 4.27734 27.461C4.09984 27.2833 4 27.0422 4 26.791V5.94728C4.00012 5.69617 4.09977 5.45493 4.27734 5.27736C4.45497 5.09981 4.69612 5.00006 4.94727 5.00002ZM10.3164 7.21388C10.3164 5.43534 12.3082 4.38515 13.7773 5.39162L27.0391 14.4776C27.3341 14.6798 27.5758 14.9504 27.7432 15.2666C27.9105 15.5829 27.9988 15.9352 28 16.293C28.0012 16.6508 27.9152 17.0039 27.75 17.3213C27.5849 17.6386 27.3454 17.911 27.0518 18.1153L13.79 27.3399C12.3234 28.3591 10.3165 27.3093 10.3164 25.5244V7.21388Z" })
});
export default SvgNextStation;
